// Generated by CoffeeScript 1.12.7
module.exports = angular.module(__filename, []).factory('rollbar', [
  '$window', function($window) {
    var Rollbar, transformer;
    Rollbar = $window.Rollbar;

    /*
    If payload contains a known error (e.g. 400s), set a custom fingerprint so that they group together
    
    Rollbar accepts a String, Object, or Error in any combination or order. From that
    it will generate a payload following these patterns:
    
    rollbar.error(String)
    - payload.data.body.message.body = string
    rollbar.error(Object)
    - payload.data.body.message.body = stringified object (if no string passed as another argument)
    - payload.data.body.message.extra = object
    rollbar.error(Error) - as long as you pass an Error as any of the three arguments, it follows this pattern
    - payload.data.body.trace.exception.class = error class name (e.g. "Error")
    - payload.data.body.trace.exception.message = error message
    - payload.data.body.trace.exception.description = if you also pass a string, adds it here
    - payload.data.body.trace.frames = stack trace
    - payload.data.body.trace.extra = if you pass an object, it goes here
    
    see rollbar.log docs for info about params:
    https://rollbar.com/docs/notifier/rollbar.js/api#rollbarlog
     */
    transformer = function(payload) {
      var angularResourceResponseData, errorMessage, fingerprint, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
      if (payload.data.level !== 'error') {
        return payload;
      }
      errorMessage = (ref = payload.data.body) != null ? (ref1 = ref.trace) != null ? (ref2 = ref1.exception) != null ? ref2.message : void 0 : void 0 : void 0;
      angularResourceResponseData = ((ref3 = payload.data.body) != null ? (ref4 = ref3.trace) != null ? ref4.extra : void 0 : void 0) || ((ref5 = payload.data.body) != null ? (ref6 = ref5.message) != null ? ref6.extra : void 0 : void 0);
      fingerprint = (angularResourceResponseData != null ? angularResourceResponseData.status : void 0) === -1 ? 'failed_to_send_request_error' : /Lot version is outdated/.test(angularResourceResponseData != null ? (ref7 = angularResourceResponseData.data) != null ? ref7.message : void 0 : void 0) ? 'lot_out_of_date_error' : (angularResourceResponseData != null ? angularResourceResponseData.status : void 0) === 401 ? 'unauthorized_error' : (angularResourceResponseData != null ? angularResourceResponseData.status : void 0) === 403 ? 'forbidden_error' : /connect ETIMEDOUT/.test(errorMessage) ? 'connection_timed_out_error' : /Could not make request to rollbar/.test(errorMessage) ? 'rollbar_connection_error' : (angularResourceResponseData != null ? (ref8 = angularResourceResponseData.data) != null ? ref8.statusCode : void 0 : void 0) === 500 && /An internal server error occurred/.test(angularResourceResponseData != null ? (ref9 = angularResourceResponseData.data) != null ? ref9.message : void 0 : void 0) ? 'internal_server_error' : void 0;
      if (fingerprint != null) {
        payload.data.fingerprint = fingerprint;
      }
      return payload;
    };
    Rollbar.configure({
      transform: transformer
    });
    return Rollbar;
  }
]);
